// extracted by mini-css-extract-plugin
module.exports = {"menuSectionItem":"MenuSectionItem_menuSectionItem__2o5XY","sectionHeader":"MenuSectionItem_sectionHeader__32JMC","menuItemList":"MenuSectionItem_menuItemList__1VJ1P"};